export default {
  article: () => import("/agt/layouts/article.vue").then(m => m.default || m),
  "lp-default": () => import("/agt/layouts/lpDefault.vue").then(m => m.default || m),
  "lp-job-position": () => import("/agt/layouts/lpJobPosition.vue").then(m => m.default || m),
  "lp-job-type": () => import("/agt/layouts/lpJobType.vue").then(m => m.default || m),
  magazine: () => import("/agt/layouts/magazine.vue").then(m => m.default || m),
  "magazine-article": () => import("/agt/layouts/magazineArticle.vue").then(m => m.default || m),
  register: () => import("/agt/layouts/register.vue").then(m => m.default || m),
  top: () => import("/agt/layouts/top.vue").then(m => m.default || m)
}